import React from 'react'

const CallsAppointmentIcon = (props: React.SVGProps<SVGSVGElement>) => (
   <svg
      xmlns="http://www.w3.org/2000/svg"
      width={32}
      height={33}
      viewBox="0 0 32 33"
      fill="none"
      {...props}
   >
      <g clipPath="url(#clip0_164_727)">
         <path
            d="M24.6667 2.97819H24V2.31152C24 1.20619 23.104 0.311523 22 0.311523C20.896 0.311523 20 1.20619 20 2.31152V2.97819H12V2.31152C12 1.20619 11.104 0.311523 10 0.311523C8.896 0.311523 8 1.20619 8 2.31152V2.97819H7.33333C3.29067 2.97819 0 6.26752 0 10.3115V24.9782C0 29.0222 3.29067 32.3115 7.33333 32.3115H24.6667C28.7093 32.3115 32 29.0222 32 24.9782V10.3115C32 6.26752 28.7093 2.97819 24.6667 2.97819ZM24.6667 28.3115H7.33333C5.49467 28.3115 4 26.8155 4 24.9782V12.3115H28V24.9782C28 26.8155 26.5053 28.3115 24.6667 28.3115ZM13.3333 16.9782V19.6449C13.3333 20.7489 12.4373 21.6449 11.3333 21.6449H8.66667C7.56267 21.6449 6.66667 20.7489 6.66667 19.6449V16.9782C6.66667 15.8742 7.56267 14.9782 8.66667 14.9782H11.3333C12.4373 14.9782 13.3333 15.8742 13.3333 16.9782Z"
            fill="white"
         />
      </g>
      <defs>
         <clipPath id="clip0_164_727">
            <rect
               width="32"
               height="32"
               fill="white"
               transform="translate(0 0.311523)"
            />
         </clipPath>
      </defs>
   </svg>
)

export default CallsAppointmentIcon
